import React from 'react';
import { Avatar, Chip, DynamicIcon } from 'legion-ui';

const handleChipClick = () => {};

const deleteChip = (e) => {
  const selectedChip = e.target.parentNode;
  selectedChip.remove();
};

const ChipSize = () => {
  return (
    <div>
      <div>
        <h4>Large</h4>
        <Chip label="primary clickable" variant="outline" size="lg" onClick={handleChipClick} />
        <Chip
          label="tertiary clickable"
          size="lg"
          variant="outline"
          color="tertiary"
          onClick={handleChipClick}
          style={{ margin: '0 6px' }}
        />
        <Chip
          label="Delete me"
          size="lg"
          variant="outline"
          color="error"
          rightIcon={<DynamicIcon name="XCircle" size="16" />}
          onClick={deleteChip}
          style={{ marginRight: '12px' }}
        />
        <Chip
          label="success!"
          size="lg"
          variant="outline"
          color="success"
          leftIcon={<DynamicIcon name="CheckCircle" size="16" />}
        />
        <Chip label="warning" size="lg" variant="outline" color="warning" style={{ margin: '0 6px' }} />
        <Chip
          label="Chip with avatar"
          size="lg"
          variant="outline"
          color="info"
          avatar={<Avatar src="https://rickandmortyapi.com/api/character/avatar/192.jpeg" />}
        />
      </div>
      <div style={{ marginTop: '1rem' }}>
        <h4>Medium</h4>
        <Chip label="primary clickable" variant="outline" size="md" onClick={handleChipClick} />
        <Chip
          label="tertiary clickable"
          size="md"
          variant="outline"
          color="tertiary"
          onClick={handleChipClick}
          style={{ margin: '0 6px' }}
        />
        <Chip
          label="Delete me"
          size="md"
          variant="outline"
          color="error"
          rightIcon={<DynamicIcon name="XCircle" size="16" />}
          onClick={deleteChip}
          style={{ marginRight: '12px' }}
        />
        <Chip
          label="success!"
          size="md"
          variant="outline"
          color="success"
          leftIcon={<DynamicIcon name="CheckCircle" size="16" />}
        />
        <Chip label="warning" size="md" variant="outline" color="warning" style={{ margin: '0 6px' }} />
        <Chip
          label="Chip with avatar"
          size="md"
          variant="outline"
          color="info"
          avatar={<Avatar src="https://rickandmortyapi.com/api/character/avatar/192.jpeg" />}
        />
      </div>
      <div style={{ marginTop: '1rem' }}>
        <h4>Small</h4>
        <Chip label="primary clickable" variant="outline" size="sm" onClick={handleChipClick} />
        <Chip
          label="tertiary clickable"
          size="sm"
          variant="outline"
          color="tertiary"
          onClick={handleChipClick}
          style={{ margin: '0 6px' }}
        />
        <Chip
          label="Delete me"
          size="sm"
          variant="outline"
          color="error"
          rightIcon={<DynamicIcon name="XCircle" size="16" />}
          onClick={deleteChip}
          style={{ marginRight: '12px' }}
        />
        <Chip
          label="success!"
          size="sm"
          variant="outline"
          color="success"
          leftIcon={<DynamicIcon name="CheckCircle" size="16" />}
        />
        <Chip label="warning" size="sm" variant="outline" color="warning" style={{ margin: '0 6px' }} />
        <Chip
          label="Chip with avatar"
          size="sm"
          variant="outline"
          color="info"
          avatar={<Avatar src="https://rickandmortyapi.com/api/character/avatar/192.jpeg" />}
        />
      </div>
    </div>
  );
};

export default ChipSize;
